<template>
  <div>
    <v-row class="row-menu-right mb-3 pl-3 pr-3">
      <v-btn
        rounded
        color="success"
        dark
        class="mr-2"
        @click="gotocreate"
      >
      <v-icon left dark color="white">fa-plus-circle</v-icon>
      Create
      </v-btn>
      <!-- <v-btn
        rounded
        color="blue-grey"
        dark
        class="mr-2"
      >
      <v-icon left dark color="white">mdi-cloud-upload</v-icon>
      Import
      </v-btn>
      <v-btn
        rounded
        color="#2196F3"
        dark
      >
      <v-icon left dark color="white" small>fa-file-export</v-icon>
      Export
      </v-btn> -->
    </v-row>
    <OverlayLoading :loading="loading" />
    <div>
      <v-data-table
        :headers="headers"
        :items="departmentData"
        class="border-table-employee"
        item-key="_id"
        group-by="orgChartHeaderName"
        :expanded.sync="expanded"
        :loading="loading"
        loading-text="Loading... Please wait"
        :footer-props="{
          'items-per-page-options': [15, 30, 50, 100, -1],
          'items-per-page': 15
        }"
        :server-items-length="total || -1"
        @update:items-per-page="changePerPage"
        @update:page="changePage"
        disable-sort
      >
      <template v-slot:[`item.no`]="{ item }">
        {{ (perPage*(page-1)) + departmentData.indexOf(item)+1 }}
      </template>
      <template v-slot:group.header="{ group, headers, toggle, isOpen }">
        <td :colspan="headers.length">
            <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
                <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
                <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
            สายงานบังคับบัญชา: {{ group }}
        </td>
      </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                color="#FFB300"
                dark
                icon
                class="btn-edit-dep mt-3 mb-3"
                @click="manageDepartment(item)"
              >
              <v-icon dark color="white" small>fa-wrench</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">จัดการฝ่ายงาน</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                rounded
                dark
                icon
                class="btn-member-dep mt-3 mb-3 ml-2"
                @click="goDialogMember(item._id)"
              >
              <v-icon dark color="white" small>fa-users</v-icon>
              </v-btn>
            </template>
            <span class="label-table-action">รายชื่อสมาขิก</span>
          </v-tooltip>
        </template>

      </v-data-table>
    </div>
    <DialogMember/>
  </div>
</template>

<script>
import { getSelectDepartment, getDepartmentList } from '@/API/API'
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
import DialogMember from '../../_template/member/dialogMember'

export default {
  components: {
    OverlayLoading, DialogMember
  },
  data () {
    return {
      expanded: [],
      keywordworkName: [],
      keywordCompanyName: '',
      keywordHeader: '',
      keywordGroupCompanyName: '',
      keywordUserName: '',
      keywordUserPosition: '',
      loading: true,
      headers: [
        {
          text: 'ลำดับ',
          align: 'center',
          value: 'no',
          sortable: false
        },
        { text: 'ชื่อฝ่ายงาน', value: 'orgChartName' },
        { text: 'สายงานบังคับบัญชา', value: 'orgChartHeaderName' },
        { text: 'ชื่อย่อบริษัท', value: 'companyShortNameEng' },
        { text: 'ชื่อเครือ', value: 'groupCompanyName' },
        { text: 'Action', align: 'center', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' }
      ],
      mockup: [],
      selectData: [],
      departmentData: [],
      departmentDataTest: [{
        no: '1',
        orgChartName: 'test',
        orgChartHeaderName: 'test',
        groupCompanyName: 'test'
      }],
      total: -1,
      perPage: 15,
      page: 1
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    try {
      this.initData()
    } catch (error) {
    } finally {
      // this.loading = false
    }
  },
  mounted () {
    EventBus.$on('filterWorkgroup', this.getSelect)
  },
  methods: {
    getSelect (data) {
      // console.log('Get Select Data Workgroup', data)
      this.keywordworkName = data.name
      this.keywordCompanyName = data.companyName
      this.keywordHeader = data.header
      this.keywordGroupCompanyName = data.groupCompany
      this.total = -1
      this.perPage = 15
      this.page = 1
      this.initDataTable()
    },
    initData () {
      this.initSelectData()
      this.initDataTable()
    },
    async initSelectData () {
      this.loading = true
      this.selectData = []
      const token = this.tokenUser

      try {
        const res = await getSelectDepartment(token)

        if (res.success) {
          if (res.result.length) {
            this.selectData = res.result
          }
        } else {
          // console.log(res)
        }
        EventBus.$emit('getFilterWorkgroup', this.selectData)
        EventBus.$emit('selectWorkgroup', res.result)
      } catch (error) {
        // alert(error)
        // console.log(error)
      } finally {
        this.loading = false
      }
    },
    changePerPage (value) {
      this.perPage = value
      this.initDataTable()
    },
    changePage (value) {
      this.page = value
      this.initDataTable()
    },
    async initDataTable () {
      this.loading = true
      this.departmentData = []
      const temp = []
      var obj = {
        name: this.keywordworkName,
        companyName: this.keywordCompanyName,
        header: this.keywordHeader,
        groupCompany: this.keywordGroupCompanyName,
        limit: this.perPage,
        page: this.page
      }

      try {
        const res = await getDepartmentList(obj, this.tokenUser)
        if (res.result) {
          // console.log(res.result)
          var filterValue = res.result.filter(r => {
            if (r.orgChartHeaderName === null) {
              // console.log('null')
              return r
            }
          })
          this.isLoading = false
          this.value = filterValue.map((orgchart, index) => {
            orgchart.orgChartHeaderName = '-'
            return orgchart
          })
          if (res.result.length) {
            res.result.map((el, index) => {
              temp.push({
                no: index + 1,
                ...el
              })
            })
            this.total = res?.count || -1
            this.departmentData = temp
          }
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    goDialogMember (id) {
      EventBus.$emit('opendialogmember', true, id)
    },
    manageDepartment (data) {
      // console.log(data)
      this.$router.push({
        name: 'ManageDepartmentUpdate',
        params: {
          item: data,
          id: data._id
        }
      })
    },
    gotocreate () {
      this.$router.push('managedepartment/create')
    }
  }
}
</script>

<style>
.v-data-table {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 16px;
}
.row-menu-left {
  justify-content: flex-start !important;
}
.row-menu-right {
  justify-content: flex-end !important;
}
.v-data-table tbody tr.v-data-table__expanded__content {
  box-shadow: inset 0px 4px 8px -5px rgba(50, 50, 50, 0), inset 0px -4px 8px -5px rgba(50, 50, 50, 0) !important;
}
.padding-left-90 {
  padding-left: 90px !important;
}
.table-name-row {
  display: flex;
  flex-direction: row;
}
</style>
